export default {
  bookExperiencePanel: 'Painel de reserva de experiência',
  calendarIcon: 'Ícone de calendário',
  coverImageForResource: 'Imagem de capa para experiências {{title}}',
  filterBy: 'Filtrar por {{filter}}',
  filterByDateRange: 'Filtrar por intervalo de datas',
  gallery: 'Galeria',
  goBack: 'Voltar para a página anterior',
  hostUserIcon: 'Ícone do usuário anfitrião',
  imageOf: 'Imagem de {{title}}',
  interactiveMapAltText: 'Mapa interativo com seleção de {{title}}',
  mediaSlides: 'Slides de mídia',
  muteVideo: 'Silenciar vídeo',
  nextPhoto: 'Próxima foto',
  noVideoPlayback: 'Sem capacidade de reprodução de vídeo',
  pauseVideo: 'Pausar vídeo',
  photoOf: 'Foto de {{name}}',
  playVideo: 'Reproduzir vídeo',
  previousPhoto: 'Foto anterior',
  moreFiltersAndExperiences: 'Mais filtros e experiências',
  reserveSelectedSlot: 'Reservar horário selecionado',
  reviewRating: 'Classificação da avaliação {{rating}} de 5',
  overallReviewRating: 'Classificação geral das avaliações {{rating}} de 5',
  selectCountryCodeForPhoneNumber:
    'Selecionar código do país para número de telefone',
  selectDate: 'Selecionar data',
  selectParticipants: 'Selecionar participantes',
  selectSessionTime: 'Selecionar horário da sessão',
  unmuteVideo: 'Ativar som do vídeo',
  viewShoppingCart: 'Ver carrinho de compras',
  itemsInCart: '{{count}} itens no carrinho de compras',
  zoomIn: 'Aproximar',
  zoomOut: 'Afastar',
  somethingWentWrong: 'Algo deu errado',
  selectData: 'Selecionar {{data}}',
  reserveName: 'Reservar {{name}}',
  deleteReservation: 'Eliminar la reserva de {{experienceTitle}}',
  editParticipantsFor: 'Editar participantes para {{experienceTitle}}',
  enterPromoCode: 'Introduza o código promocional',
  applyPromoCode: 'Aplicar código promocional',
  increaseAddOnAmount: 'Aumentar {{addOn}} seleccionado',
  decreaseAddOnAmount: 'Diminuir {{addOn}} seleccionado',
  addOnModal: '{{addOn}} modal',
  moreInformationAboutAddOn: 'Mais informações sobre {{addOn}}',
  decreasePriceTierTickets: 'Diminuir {{priceTier}} bilhetes',
  increasePriceTierTickets: 'Aumentar {{priceTier}} bilhetes',
  downloadFilename: 'Descarregar {{filename}}',
  viewFullDetailsDescription: 'Ver descrição completa dos detalhes',
  viewFullDescription: 'Ver descrição completa',
  closeModal: 'Fechar modal',
  hyattBanner: 'Banner exclusivo para membros World of Hyatt',
  hyattBannerDesc:
    'Banner promocional indicando benefícios e ofertas exclusivos disponíveis para os membros do programa de fidelidade World of Hyatt',
  previousSlide: 'Slide anterior',
  nextSlide: 'Slide seguinte',
  paginationBulletMessage: 'Ir para o slide',
  exitFullscreen: 'Sair do modo de tela cheia',
  enterFullscreen: 'Entrar no modo de tela cheia',
  videoSlide: 'Slide de vídeo',
  imageSlide: 'Slide de imagem',
  of: 'de',
  noDescription: 'Sem descrição',
  mediaGallery: 'Carrossel - Galeria de mídia',
  dateSelector: 'Seletor de data',
  nextWeek: 'Próxima semana',
  previousWeek: 'Semana anterior',
  scheduleAgenda: 'Agenda do cronograma',
  scheduleNav: 'Navegação do cronograma',
  scheduleViewSelector: 'Seletor de visualização do cronograma',
  selectedDateAriaLabel: '{{date}}, selecionado',
  tapToBookExperience: 'Reservar {{title}}',
  bookExperienceAriaLabel: 'Reservar {{title}}',
  joinWaitlistAriaLabel: 'Entrar na lista de espera para {{title}}',
};
